import {DataItem, TextInput} from 'src/design-system';
import React from 'react';
import * as Yup from 'yup';
import {Text} from 'react-native';
import {Typography} from 'src/styles';
import {IDeveloperField} from 'dromo-uploader-react';

interface DisplayProps {
  value: string;
}

interface Props {
  valueKey: string;
}

export const Import = (
  key: string = 'firstName',
  prefix?: string,
  required: boolean = true,
): IDeveloperField => ({
  label: (prefix ? prefix + ' ' : '') + 'First Name',
  key,
  validators: required
    ? [
        {
          validate: 'required',
        },
      ]
    : [],
});

const resolveDisplayValue = (value: string) => {
  return value;
};

const LastNameDisplay = ({value}: DisplayProps) => {
  return (
    <DataItem>
      <Text style={[Typography.H6]}>First Name</Text>
      <Text style={[Typography.P3]}>{resolveDisplayValue(value)}</Text>
    </DataItem>
  );
};

const LastNameInput = ({valueKey}: Props) => {
  return (
    <TextInput
      valueKey={(valueKey ? valueKey + '.' : '') + 'firstName'}
      name={'First Name'}
      required={true}
    />
  );
};

export const validation = () => Yup.string().required('First name is required');

export const Display = LastNameDisplay;
export const Input = LastNameInput;
export const Value = resolveDisplayValue;

export default LastNameInput;
